var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwiftAch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 3.22133e-08 18.2091 0 16V7H5.33301C5.7012 7 6 6.77614 6 6.5C6 6.22386 5.7012 6 5.33301 6H0V5H3.5C3.77614 5 4 4.77614 4 4.5C4 4.22386 3.77614 4 3.5 4H0C0 1.79086 1.79086 3.22128e-08 4 0H16Z",
    fill: "url(#paint0_linear_3126_29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03423 13H12.9658M9.5 9.53123V13M11.8105 9.53123V13M7.18949 9.53123V13M9.67221 7.03989L12.8079 8.57801C13.135 8.73846 13.0186 9.22213 12.6529 9.22213H6.3471C5.98138 9.22213 5.865 8.73846 6.1921 8.57801L9.32779 7.03989C9.43619 6.9867 9.56381 6.9867 9.67221 7.03989Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1428 3L14 5.5H17L14.8572 8",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1428 3L14 5.5H17L14.8572 8",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5C18 15.163 17.7366 15.7989 17.2678 16.2678C16.7989 16.7366 16.163 17 15.5 17C14.837 17 14.2011 16.7366 13.7322 16.2678C13.2634 15.7989 13 15.163 13 14.5C13 13.837 13.2634 13.2011 13.7322 12.7322C14.2011 12.2634 14.837 12 15.5 12C16.163 12 16.7989 12.2634 17.2678 12.7322C17.7366 13.2011 18 13.837 18 14.5Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2975 13.0815V14.7031H16.3785",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3126_29",
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C40A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474DE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftAch);
export default __webpack_public_path__ + "static/media/SwiftAch.dd6e77a4a240d653925166aa55522552.svg";
export { ForwardRef as ReactComponent };